export const crcotnMonsters = [
  {
    name: "Aboleth Spawn",
    source: "CRCotN",
    page: 135,
    size: ["M"],
    type: "aberration",
    alignment: ["L", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 93,
      formula: "11d8 + 44",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 19,
    dex: 11,
    con: 18,
    int: 7,
    wis: 12,
    cha: 9,
    skill: {
      perception: "+4",
    },
    senses: ["darkvision 120 ft."],
    passive: 14,
    resist: ["psychic"],
    conditionImmune: ["charmed", "frightened"],
    languages: ["Common", "Deep Speech", "telepathy 60 ft."],
    cr: "5",
    trait: [
      {
        name: "Abolethic Vessel",
        entries: ["The spawn must obey its aboleth master."],
      },
      {
        name: "Amphibious",
        entries: ["The spawn can breathe air and water."],
      },
      {
        name: "Water Dependency",
        entries: [
          "The spawn takes 6 ({@damage 1d12}) acid damage every 10 minutes it goes without being immersed in water.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The spawn makes one Spear attack, two Tentacle attacks, and one Psychic Lash attack.",
        ],
      },
      {
        name: "Spear",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d6 + 4}) piercing damage, or 8 ({@damage 1d8 + 4}) piercing damage when used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Tentacle",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one creature. {@h}The target is {@condition grappled} (escape {@dc 14}) and takes 9 ({@damage 2d8}) psychic damage at the start of each of its turns until the grapple ends. The spawn has four tentacles, each of which can grapple one creature.",
        ],
      },
      {
        name: "Psychic Lash",
        entries: [
          "{@atk rs} {@hit 7} to hit, range 120 ft., one creature. {@h}18 ({@damage 4d8}) psychic damage.",
        ],
      },
    ],
    attachedItems: ["spear|phb"],
    traitTags: ["Amphibious"],
    senseTags: ["SD"],
    actionTags: ["Multiattack", "Tentacles"],
    languageTags: ["C", "DS", "TP"],
    damageTags: ["A", "P", "Y"],
    miscTags: ["MW", "RCH", "RW", "THW"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Agathe Silverspoon",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 21,
    _copy: {
      name: "Orc",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the orc",
          with: "Agathe",
          flags: "i",
        },
      },
    },
    alignment: ["C", "G"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Aloysia Telfan",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 61,
    _copy: {
      name: "Occult Initiate",
      source: "CRCotN",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the initiate",
          with: "Aloysia",
          flags: "i",
        },
      },
    },
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["elf", "sorcerer"],
    },
    alignment: ["L", "E"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Alyxian Aboleth",
    source: "CRCotN",
    page: 195,
    size: ["L"],
    type: "aberration",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 135,
      formula: "18d10 + 36",
    },
    speed: {
      walk: 10,
      swim: 30,
    },
    str: 21,
    dex: 9,
    con: 15,
    int: 18,
    wis: 18,
    cha: 18,
    save: {
      con: "+6",
      int: "+8",
      wis: "+8",
    },
    skill: {
      history: "+12",
      perception: "+12",
    },
    senses: ["darkvision 120 ft."],
    passive: 22,
    languages: ["Deep Speech", "telepathy 120 ft."],
    cr: "12",
    trait: [
      {
        name: "Amphibious",
        entries: ["The aboleth can breathe air and water."],
      },
      {
        name: "Mucous Cloud",
        entries: [
          "While underwater, the aboleth is surrounded by a cloud of sticky mucus. A creature that touches the aboleth or hits it with a melee attack while within 5 feet of it must succeed on a {@dc 14} Strength saving throw or be {@condition restrained} until the end of the aboleth's next turn.",
        ],
      },
      {
        name: "Probing Telepathy",
        entries: [
          "If a creature the aboleth can see communicates telepathically with the aboleth, the aboleth learns the creature's greatest desires.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The aboleth makes two Tentacle attacks."],
      },
      {
        name: "Tentacle",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}12 ({@damage 2d6 + 5}) bludgeoning damage plus 3 ({@damage 1d6}) psychic damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}14 ({@damage 2d8 + 5}) bludgeoning damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Enslave {@recharge 4}",
        entries: [
          "The aboleth targets one creature it can see within 30 feet of itself. The target must succeed on a {@dc 14} Wisdom saving throw or be magically {@condition charmed} by the aboleth until the aboleth dies or until it is on a different plane of existence from the target. The {@condition charmed} target is under the aboleth's control and can't take reactions, and the aboleth and the target can communicate telepathically with each other over any distance.",
          "The {@condition charmed} target can repeat the saving throw whenever it takes damage, ending the effect on itself on a success. No more than once every 24 hours, the target can repeat the saving throw when it is at least 1 mile away from the aboleth.",
        ],
      },
    ],
    legendary: [
      {
        name: "Tail Swipe",
        entries: ["The aboleth makes one Tail attack."],
      },
      {
        name: "Psychic Drain (Costs 2 Actions)",
        entries: [
          "One creature {@condition charmed} by the aboleth takes 10 ({@damage 3d6}) psychic damage, and the aboleth regains hit points equal to the damage dealt.",
        ],
      },
    ],
    traitTags: ["Amphibious"],
    senseTags: ["SD"],
    actionTags: ["Multiattack", "Tentacles"],
    languageTags: ["DS", "TP"],
    damageTags: ["B", "Y"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["charmed", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Alyxian the Absolved",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 182,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "G"],
    ac: [
      {
        ac: 15,
        from: ["{@item leather armor|PHB}", "{@item shield|PHB}"],
      },
    ],
    hp: {
      average: 161,
      formula: "19d8 + 76",
    },
    speed: {
      walk: 30,
    },
    str: 19,
    dex: 15,
    con: 18,
    int: 13,
    wis: 14,
    cha: 19,
    save: {
      str: "+9",
      con: "+9",
      wis: "+7",
    },
    skill: {
      athletics: "+9",
      insight: "+7",
      perception: "+7",
      persuasion: "+9",
    },
    senses: ["darkvision 120 ft."],
    passive: 17,
    languages: ["Common", "Elvish"],
    cr: "14",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Alyxian casts one of the following spells, requiring no material components and using Charisma as the spellcasting modifier (spell save {@dc 17}):",
        ],
        will: ["{@spell guidance}", "{@spell light}"],
        daily: {
          "1e": [
            "{@spell lesser restoration}",
            "{@spell remove curse}",
            "{@spell water breathing}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Divinely Blessed",
        entries: [
          "Alyxian can't be {@quickref Surprise|PHB|3|0|surprised} and can't be changed into another form against his will.",
        ],
      },
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If Alyxian fails a saving throw, he can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Alyxian makes two Spear attacks."],
      },
      {
        name: "Spear",
        entries: [
          "{@atk mw,rw} {@hit 9} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d6 + 4}) piercing damage, or 8 ({@damage 1d8 + 4}) piercing damage when used with two hands to make a melee attack, plus 9 ({@damage 2d8}) radiant damage.",
        ],
      },
      {
        name: "Force Wave (1/Day)",
        entries: [
          "Alyxian strikes the ground, creating a burst of energy that ripples outward. Each creature he chooses within a 30-foot-radius sphere centered on himself must succeed on a {@dc 17} Constitution saving throw or take 35 ({@damage 10d6}) force damage and be knocked {@condition prone}. A creature that succeeds on the saving throw takes half as much damage and isn't knocked {@condition prone}.",
        ],
      },
    ],
    reaction: [
      {
        name: "Parry",
        entries: [
          "Alyxian adds 3 to his AC against one attack roll that would hit him. To do so, Alyxian must see the attacker and be wielding a melee weapon.",
        ],
      },
    ],
    legendary: [
      {
        name: "Arch Heart's Strike",
        entries: [
          "Alyxian makes one Spear attack, and all damage from this attack is radiant.",
        ],
      },
      {
        name: "Change Bringer's Dance",
        entries: [
          "Alyxian moves up to his speed. This movement doesn't provoke opportunity attacks.",
        ],
      },
      {
        name: "Moon Weaver's Veil (Costs 2 Actions)",
        entries: [
          "Alyxian becomes {@condition invisible} until the end of his next turn. Any equipment he is wearing or carrying becomes {@condition invisible} with him.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Alyxian the Absolved",
      source: "CRCotN",
    },
    attachedItems: ["spear|phb"],
    traitTags: ["Legendary Resistances"],
    senseTags: ["SD"],
    actionTags: ["Multiattack", "Parry"],
    languageTags: ["C", "E"],
    damageTags: ["O", "P", "R"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Alyxian the Callous",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 179,
    size: ["L"],
    type: "celestial",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["{@item half plate armor|PHB|half plate}"],
      },
    ],
    hp: {
      average: 157,
      formula: "15d10 + 75",
    },
    speed: {
      walk: 30,
      fly: 90,
    },
    str: 23,
    dex: 18,
    con: 21,
    int: 15,
    wis: 16,
    cha: 20,
    save: {
      str: "+10",
      con: "+9",
      wis: "+7",
    },
    skill: {
      deception: "+9",
      insight: "+7",
      perception: "+7",
    },
    senses: ["truesight 120 ft."],
    passive: 17,
    immune: ["radiant"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "restrained",
      "stunned",
    ],
    languages: ["Celestial", "Common", "Elvish", "telepathy 120 ft."],
    cr: "12",
    trait: [
      {
        name: "Apotheonic Rejuvenation",
        entries: [
          "When Alyxian the Callous drops to 0 hit points, his body dies and sheds its wings, and he rises to his feet in his third form, Alyxian the Dispossessed. His initiative count doesn't change.",
        ],
      },
      {
        name: "Divinely Blessed",
        entries: [
          "Alyxian can't be {@quickref Surprise|PHB|3|0|surprised} and can't be changed into another form against his will.",
        ],
      },
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If Alyxian fails a saving throw, he can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Alyxian makes two Radiant Spear attacks. He can replace one of these attacks with Blinding Teleport.",
        ],
      },
      {
        name: "Radiant Spear",
        entries: [
          "{@atk mw,rw} {@hit 10} to hit, reach 5 ft. or range 120 ft., one target. {@h}15 ({@damage 2d8 + 6}) radiant damage.",
        ],
      },
      {
        name: "Blinding Teleport",
        entries: [
          "Alyxian teleports, along with any equipment he is wearing or carrying, to an unoccupied space he can see within 120 feet of himself. Each creature within 5 feet of his new location must succeed on a {@dc 17} Constitution saving throw or be {@condition blinded} until the end of its next turn.",
        ],
      },
      {
        name: "Heavenly Destruction (1/Day)",
        entries: [
          "Alyxian releases divine energy in a 60-foot cone. Each creature of his choice in that area must make a {@dc 17} Constitution saving throw. On a failed saving throw, the creature takes 31 ({@damage 7d8}) radiant damage and is knocked {@condition prone}. On a successful save, a creature takes half as much damage and isn't knocked {@condition prone}.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["Alyxian makes one Radiant Spear attack."],
      },
      {
        name: "Celestial Chains",
        entries: [
          "Alyxian targets one creature he can see within 120 feet of himself. The target must succeed on a {@dc 17} Strength saving throw or be {@condition restrained} by magical chains for 1 minute. While {@condition restrained} in this way, the target can't leave the space by any means. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
      {
        name: "Flare (Costs 2 Actions)",
        entries: [
          "Alyxian targets one creature he can see within 30 feet of himself. Light flares around the target, dealing 17 ({@damage 5d6}) radiant damage to it and creatures within 10 feet of it.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Alyxian the Callous",
      source: "CRCotN",
    },
    traitTags: ["Legendary Resistances"],
    senseTags: ["U"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CE", "E", "TP"],
    damageTags: ["R"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    conditionInflict: ["blinded", "prone", "restrained"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Alyxian the Dispossessed",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 180,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 15,
        from: ["{@item leather armor|PHB}", "{@item shield|PHB}"],
      },
    ],
    hp: {
      average: 153,
      formula: "18d8 + 72",
    },
    speed: {
      walk: 30,
    },
    str: 19,
    dex: 15,
    con: 18,
    int: 13,
    wis: 14,
    cha: 20,
    save: {
      str: "+9",
      con: "+9",
      wis: "+7",
    },
    skill: {
      insight: "+7",
      perception: "+7",
      persuasion: "+10",
    },
    senses: ["darkvision 120 ft."],
    passive: 17,
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "stunned",
    ],
    languages: ["Celestial", "Common", "Elvish", "telepathy 120 ft."],
    cr: "13",
    trait: [
      {
        name: "Divinely Blessed",
        entries: [
          "Alyxian can't be {@quickref Surprise|PHB|3|0|surprised} and can't be changed into another form against his will.",
        ],
      },
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If Alyxian fails a saving throw, he can choose to succeed instead.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Alyxian carries a magic dagger that he uses to make Stoneheart Dagger attacks. In the hands of creatures other than Alyxian, the dagger is nonmagical and has no special properties.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Alyxian makes two Spear attacks."],
      },
      {
        name: "Spear",
        entries: [
          "{@atk mw,rw} {@hit 9} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d6 + 4}) piercing damage, or 8 ({@damage 1d8 + 4}) piercing damage when used with two hands to make a melee attack, plus 9 ({@damage 2d8}) radiant damage.",
        ],
      },
      {
        name: "Stoneheart Dagger",
        entries: [
          "{@atk mw,rw} {@hit 9} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}11 ({@damage 3d4 + 4}) force damage, and if the target is a creature, it must succeed on a {@dc 17} Constitution saving throw or become {@condition petrified} as the dagger lodges itself in the target's body. While the dagger is lodged in the target, magic can't end the {@condition petrified} condition on it and Alyxian can't make Stoneheart Dagger attacks. A creature within reach of the {@condition petrified} target can use an action to try to remove the dagger, doing so with a successful {@dc 17} Strength check.",
        ],
      },
    ],
    bonus: [
      {
        name: "Summon Dagger",
        entries: [
          "Alyxian's Stoneheart Dagger teleports into his free hand, provided he has one.",
        ],
      },
    ],
    reaction: [
      {
        name: "Parry",
        entries: [
          "Alyxian adds 3 to his AC against one attack roll that would hit him. To do so, Alyxian must see the attacker and be wielding a melee weapon.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["Alyxian makes one Spear or Stoneheart Dagger attack."],
      },
      {
        name: "Warrior's Stride",
        entries: [
          "Alyxian moves up to his speed. This movement doesn't provoke opportunity attacks.",
        ],
      },
      {
        name: "Ruidium Shard (Costs 2 Actions)",
        entries: [
          "A gem-sized shard of ruidium appears at a point Alyxian can see within 120 feet of himself and explodes. Each creature, other than Alyxian, in a 10-foot-radius sphere centered on that point must succeed on a {@dc 18} Charisma saving throw or gain 1 level of {@condition exhaustion}. If a creature isn't suffering from ruidium corruption, it becomes corrupted when it fails the saving throw.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Alyxian the Dispossessed",
      source: "CRCotN",
    },
    attachedItems: ["spear|phb"],
    traitTags: ["Legendary Resistances"],
    senseTags: ["SD"],
    actionTags: ["Multiattack", "Parry"],
    languageTags: ["C", "CE", "E", "TP"],
    damageTags: ["O", "P", "R"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    conditionInflict: ["exhaustion", "petrified"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Alyxian the Hunter",
    source: "CRCotN",
    page: 160,
    size: ["M"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 178,
      formula: "17d10 + 85",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 22,
    dex: 9,
    con: 20,
    int: 3,
    wis: 11,
    cha: 1,
    senses: ["darkvision 120 ft."],
    passive: 10,
    immune: [
      "poison",
      "psychic",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks that aren't adamantine",
        cond: true,
      },
    ],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands the languages of its creator but can't speak"],
    cr: "10",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The golem is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The golem has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["The golem's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The golem makes two slam attacks."],
      },
      {
        name: "Ruidium Dart",
        entries: [
          "The golem can conjure a magic dart made of ruidium and hurl it at another creature it can see within 120 feet of itself. The dart strikes the target unerringly and vanishes on contact. The target must make a {@dc 17} Charisma saving throw. On a failed saving throw, the target takes 24 ({@damage 7d6}) psychic damage and gains 1 level of {@condition exhaustion}. In addition, if the target is not already suffering from ruidium corruption, it becomes corrupted when it fails the saving throw. On a successful saving throw, the target takes half as much damage and suffers no other effects.",
        ],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one target. {@h}19 ({@damage 3d8 + 6}) bludgeoning damage.",
        ],
      },
      {
        name: "Slow {@recharge 5}",
        entries: [
          "The golem targets one or more creatures it can see within 10 feet of it. Each target must make a {@dc 17} Wisdom saving throw against this magic. On a failed save, a target can't use reactions, its speed is halved, and it can't make more than one attack on its turn. In addition, the target can take either an action or a bonus action on its turn, not both. These effects last for 1 minute. A target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    attachedItems: ["ruidium dart|crcotn"],
    traitTags: ["Immutable Form", "Magic Resistance", "Magic Weapons"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["CS"],
    damageTags: ["B", "Y"],
    miscTags: ["MW"],
    conditionInflict: ["exhaustion"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Alyxian the Tormented",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 178,
    size: ["H"],
    type: "aberration",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 150,
      formula: "12d12 + 72",
    },
    speed: {
      walk: 40,
      swim: 40,
    },
    str: 21,
    dex: 18,
    con: 22,
    int: 15,
    wis: 16,
    cha: 20,
    save: {
      str: "+9",
      con: "+10",
      wis: "+7",
    },
    skill: {
      deception: "+9",
      insight: "+7",
      perception: "+7",
    },
    senses: ["blindsight 120 ft."],
    passive: 17,
    immune: ["necrotic"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "stunned",
    ],
    languages: ["Celestial", "Common", "Elvish", "telepathy 120 ft."],
    cr: "11",
    trait: [
      {
        name: "Apotheonic Rejuvenation",
        entries: [
          "When Alyxian drops to 0 hit points, his body dies and cracks open like a cocoon. Alyxian instantly emerges from the cocoon in his second form, Alyxian the Callous, in the space where his previous form died. His initiative count doesn't change.",
        ],
      },
      {
        name: "Divinely Blessed",
        entries: [
          "Alyxian can't be {@quickref Surprise|PHB|3|0|surprised} and can't be changed into another form against his will.",
        ],
      },
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If Alyxian fails a saving throw, he can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Alyxian makes two Grasping Hand attacks."],
      },
      {
        name: "Grasping Hand",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}15 ({@damage 3d6 + 5}) force damage, and if the target is a Medium or smaller creature, it is {@condition grappled} (escape {@dc 15}). Alyxian has six hands, each of which can grapple one target.",
        ],
      },
      {
        name: "Void Eyes {@recharge 5}",
        entries: [
          "Alyxian targets up to two creatures he can see within 120 feet of himself. Each target must make a {@dc 17} Constitution saving throw, taking 28 ({@damage 8d6}) necrotic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["Alyxian makes one Grasping Hand attack."],
      },
      {
        name: "Weapons of Yore (Costs 2 Actions)",
        entries: [
          "Ancient weapons embedded in Alyxian's hide detach from Alyxian and fly about in a 10-foot-radius sphere centered on a point Alyxian can see within 60 feet of himself. A creature takes 18 ({@damage 4d8}) slashing damage when it enters that area for the first time on a turn or starts its turn there. The effect lasts until the end of Alyxian's next turn, when the weapons return to Alyxian and embed themselves in his hide once again (causing him no harm).",
        ],
      },
    ],
    legendaryGroup: {
      name: "Alyxian the Tormented",
      source: "CRCotN",
    },
    traitTags: ["Legendary Resistances"],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CE", "E", "TP"],
    damageTags: ["N", "O", "S"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Animated Glass Statue",
    source: "CRCotN",
    page: 109,
    size: ["L"],
    type: "construct",
    alignment: ["N", "E"],
    ac: [10],
    hp: {
      average: 22,
      formula: "3d10 + 6",
    },
    speed: {
      walk: 10,
      fly: 60,
    },
    str: 15,
    dex: 10,
    con: 15,
    int: 6,
    wis: 12,
    cha: 7,
    skill: {
      perception: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands Common but can't speak it"],
    cr: "1",
    trait: [
      {
        name: "Keen Sight and Smell",
        entries: [
          "The statue has advantage on Wisdom (Perception) checks that rely on sight or smell.",
        ],
      },
      {
        name: "Pack Tactics",
        entries: [
          "The statue has advantage on an attack roll against a creature if at least one of the statue's allies is within 5 feet of the creature and the ally isn't {@condition incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The statue makes two attacks: one with its beak and one with its talons.",
        ],
      },
      {
        name: "Beak",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}7 ({@damage 2d4 + 2}) piercing damage.",
        ],
      },
      {
        name: "Talons",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}9 ({@damage 2d6 + 2}) slashing damage.",
        ],
      },
    ],
    traitTags: ["Keen Senses", "Pack Tactics"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CS"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    hasToken: true,
  },
  {
    name: "Aradrine the Owl",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 82,
    _copy: {
      name: "Occult Silvertongue",
      source: "CRCotN",
      _trait: {
        name: "Goliath",
        source: "VGM",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the silvertongue",
          with: "Aradrine",
          flags: "i",
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["goliath", "sorcerer"],
    },
    alignment: ["L", "N"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Ashann",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 115,
    _copy: {
      name: "Occult Initiate",
      source: "CRCotN",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the initiate",
          with: "Ashann",
          flags: "i",
        },
      },
    },
    size: ["S"],
    type: {
      type: "humanoid",
      tags: ["gnome", "sorcerer"],
    },
    alignment: ["C", "N"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Ayo Jabe (Tier 1)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 188,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: [
        "ranger",
        {
          tag: "genasi",
          prefix: "Water",
        },
      ],
    },
    alignment: ["C", "G"],
    ac: [
      {
        ac: 14,
        from: ["{@item studded leather armor|PHB|studded leather}"],
      },
    ],
    hp: {
      average: 65,
      formula: "10d8 + 20",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 14,
    dex: 14,
    con: 14,
    int: 10,
    wis: 12,
    cha: 12,
    save: {
      str: "+4",
      dex: "+4",
    },
    skill: {
      athletics: "+4",
      perception: "+3",
      survival: "+3",
    },
    passive: 13,
    resist: ["acid"],
    languages: ["Common", "Goblin", "Orc"],
    cr: "3",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Ayo casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 11}):",
        ],
        daily: {
          "1e": ["{@spell animal friendship}", "{@spell goodberry}"],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["Ayo can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Ayo makes two Harpoon or Longbow attacks."],
      },
      {
        name: "Harpoon",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}11 ({@damage 2d8 + 2}) piercing damage.",
        ],
      },
      {
        name: "Longbow",
        entries: [
          "{@atk rw} {@hit 4} to hit, range 150/600 ft., one target. {@h}11 ({@damage 2d8 + 2}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["longbow|phb"],
    traitTags: ["Amphibious"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["P"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RNG", "RW"],
    conditionInflictSpell: ["charmed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ayo Jabe (Tier 2)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 190,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: [
        "ranger",
        {
          tag: "genasi",
          prefix: "Water",
        },
      ],
    },
    alignment: ["C", "G"],
    ac: [
      {
        ac: 15,
        from: ["{@item studded leather armor|PHB|studded leather}"],
      },
    ],
    hp: {
      average: 97,
      formula: "15d8 + 30",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 14,
    dex: 16,
    con: 14,
    int: 10,
    wis: 14,
    cha: 12,
    save: {
      str: "+5",
      dex: "+6",
    },
    skill: {
      athletics: "+5",
      perception: "+5",
      survival: "+5",
    },
    passive: 15,
    resist: ["acid"],
    languages: ["Common", "Goblin", "Orc"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Ayo casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 13}):",
        ],
        daily: {
          "1e": [
            "{@spell animal friendship}",
            "{@spell goodberry}",
            "{@spell pass without trace}",
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["Ayo can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Ayo makes three Harpoon or Longbow attacks."],
      },
      {
        name: "Harpoon",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}11 ({@damage 2d8 + 2}) piercing damage.",
        ],
      },
      {
        name: "Longbow",
        entries: [
          "{@atk rw} {@hit 6} to hit, range 150/600 ft., one target. {@h}12 ({@damage 2d8 + 3}) piercing damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Reposition",
        entries: [
          "Ayo issues orders to one ally she can see within 30 feet of herself. If the target can see or hear Ayo, it can spend its reaction to move up to its speed. This movement doesn't provoke opportunity attacks.",
        ],
      },
    ],
    attachedItems: ["longbow|phb"],
    traitTags: ["Amphibious"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["P"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RNG", "RW"],
    conditionInflictSpell: ["charmed"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Ayo Jabe (Tier 3)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 192,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: [
        "ranger",
        {
          tag: "genasi",
          prefix: "Water",
        },
      ],
    },
    alignment: ["C", "G"],
    ac: [
      {
        ac: 17,
        from: ["{@item studded leather armor|PHB|studded leather}"],
      },
    ],
    hp: {
      average: 150,
      formula: "20d8 + 60",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 16,
    dex: 20,
    con: 16,
    int: 10,
    wis: 16,
    cha: 14,
    save: {
      str: "+6",
      dex: "+8",
    },
    skill: {
      athletics: "+6",
      perception: "+6",
      survival: "+6",
    },
    passive: 16,
    resist: ["acid"],
    conditionImmune: ["frightened"],
    languages: ["Common", "Goblin", "Orc"],
    cr: "8",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Ayo casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 14}):",
        ],
        daily: {
          "1e": [
            "{@spell animal friendship}",
            "{@spell freedom of movement}",
            "{@spell goodberry}",
            "{@spell pass without trace}",
            "{@spell protection from energy}",
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["Ayo can breathe air and water."],
      },
      {
        name: "Special Equipment",
        entries: [
          "Ayo wields a ruidium harpoon (see appendix B). If Ayo rolls a 1 on an attack roll made with the harpoon, she must succeed on a {@dc 20} Charisma saving throw or gain 1 level of {@condition exhaustion}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Ayo makes three Harpoon or Longbow attacks."],
      },
      {
        name: "Ruidium Harpoon",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}12 ({@damage 2d8 + 3}) piercing damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
      {
        name: "Longbow",
        entries: [
          "{@atk rw} {@hit 8} to hit, range 150/600 ft., one target. {@h}18 ({@damage 3d8 + 5}) piercing damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Reposition",
        entries: [
          "Ayo issues orders to one ally she can see within 30 feet of herself. If the target can see or hear Ayo, it can spend its reaction to move up to its speed. This movement doesn't provoke opportunity attacks.",
        ],
      },
    ],
    attachedItems: ["longbow|phb"],
    traitTags: ["Amphibious"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["P", "Y"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RNG", "RW"],
    conditionInflict: ["exhaustion"],
    conditionInflictSpell: ["charmed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Celeste",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 150,
    _copy: {
      name: "Ghost",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the ghost",
          with: "Celeste",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Corrupted Giant Shark",
    source: "CRCotN",
    page: 196,
    size: ["H"],
    type: "aberration",
    alignment: ["U"],
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 126,
      formula: "11d12 + 55",
    },
    speed: {
      walk: 0,
      swim: 50,
    },
    str: 23,
    dex: 11,
    con: 21,
    int: 1,
    wis: 10,
    cha: 5,
    skill: {
      perception: "+4",
    },
    senses: ["blindsight 60 ft."],
    passive: 14,
    cr: "9",
    trait: [
      {
        name: "Psychic Maelstrom",
        entries: [
          "Any creature that starts its turn within 15 feet of the shark must succeed on a {@dc 17} Wisdom saving throw or take 11 ({@damage 2d10}) psychic damage.",
        ],
      },
      {
        name: "Regeneration",
        entries: [
          "The shark regains 10 hit points at the start of its turn. If the shark takes radiant damage or suffers a critical hit, this trait doesn't function at the start of its next turn. The shark dies only if it starts its turn with 0 hit points and doesn't regenerate.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The shark can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 10} to hit (with advantage if the target is a creature missing any hit points), reach 5 ft., one target. {@h}22 ({@damage 3d10 + 6}) piercing damage, and if the target is a creature, it must succeed on a {@dc 17} Charisma saving throw or gain 1 level of {@condition exhaustion}.",
        ],
      },
    ],
    traitTags: ["Regeneration", "Water Breathing"],
    senseTags: ["B"],
    damageTags: ["P", "Y"],
    miscTags: ["MW"],
    conditionInflict: ["exhaustion"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dancing Flame",
    source: "CRCotN",
    page: 68,
    size: ["M"],
    type: "fiend",
    alignment: ["N", "E"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 66,
      formula: "12d8 + 12",
    },
    speed: {
      walk: 30,
      fly: 60,
    },
    str: 8,
    dex: 17,
    con: 13,
    int: 15,
    wis: 12,
    cha: 20,
    skill: {
      deception: "+9",
      insight: "+5",
      perception: "+5",
      persuasion: "+9",
      stealth: "+7",
    },
    senses: ["darkvision 60 ft."],
    passive: 15,
    resist: [
      "cold",
      "fire",
      "lightning",
      "poison",
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    languages: ["Abyssal", "Common", "Infernal", "telepathy 60 ft."],
    cr: "4",
    trait: [
      {
        name: "Telepathic Bond",
        entries: [
          "The flame ignores the range restriction on its telepathy when communicating with a creature it has {@condition charmed}. The two don't even need to be on the same plane of existence.",
        ],
      },
      {
        name: "Flame",
        entries: [
          "The flame sheds bright light in a 20-foot radius and dim light for an additional 20 feet. If it leaves the hall or is reduced to 0 hit points, it is destroyed and can't re-form for 24 hours.",
        ],
      },
    ],
    action: [
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}6 ({@damage 1d6 + 3}) fire damage.",
        ],
      },
      {
        name: "Charm",
        entries: [
          "One humanoid the flame can see within 30 feet of it must succeed on a {@dc 15} Wisdom saving throw or be magically {@condition charmed} for 1 day. The {@condition charmed} target obeys the flame's verbal or telepathic commands. If the target suffers any harm or receives a suicidal command, it can repeat the saving throw, ending the effect on a success. If the target successfully saves against the effect, or if the effect on it ends, the target is immune to this flame's Charm for the next 24 hours.",
          "The flame can have only one target {@condition charmed} at a time. If it charms another, the effect on the previous target ends.",
        ],
      },
      {
        name: "Draining Kiss",
        entries: [
          "The flame kisses a creature {@condition charmed} by it or a willing creature. The target must make a {@dc 15} Constitution saving throw against this magic, taking 32 ({@damage 5d10 + 5}) psychic damage on a failed save, or half as much damage on a successful one. The target's hit point maximum is reduced by an amount equal to the damage taken. This reduction lasts until the target finishes a long rest. The target dies if this effect reduces its hit point maximum to 0.",
        ],
      },
    ],
    senseTags: ["D"],
    languageTags: ["AB", "C", "I", "TP"],
    damageTags: ["F", "Y"],
    miscTags: ["AOE", "HPR", "MW"],
    conditionInflict: ["charmed"],
    hasToken: true,
  },
  {
    name: "Death Embrace",
    source: "CRCotN",
    page: 197,
    size: ["H"],
    type: "aberration",
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 147,
      formula: "14d12 + 56",
    },
    speed: {
      walk: 0,
      swim: 20,
    },
    str: 23,
    dex: 15,
    con: 19,
    int: 6,
    wis: 9,
    cha: 4,
    save: {
      str: "+10",
      wis: "+3",
    },
    senses: ["blindsight 60 ft. (blind beyond this radius)"],
    passive: 9,
    conditionImmune: ["exhaustion", "paralyzed", "petrified", "prone"],
    cr: "11",
    trait: [
      {
        name: "Petrifying Tendrils",
        entries: [
          "Any creature that starts its turn in the death embrace's space must make a {@dc 16} Constitution saving throw. On a failed saving throw, the creature is {@condition restrained}. A creature {@condition restrained} in this way must repeat the saving throw at the end of its next turn, becoming {@condition petrified} on a failed saving throw or ending the effect on a successful one. The {@condition petrified} condition lasts until the effect is ended by a greater restoration spell or similar magic.",
        ],
      },
      {
        name: "Reel",
        entries: [
          "At the start of each of its turns, the death embrace can pull each creature it is grappling up to 20 feet toward it (no action required).",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The death embrace can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The death embrace makes two Tentacle attacks."],
      },
      {
        name: "Tentacle",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 60 ft., one target. {@h}13 ({@damage 2d6 + 6}) piercing damage plus 11 ({@damage 2d10}) psychic damage. If the target is Large or smaller, it is also {@condition grappled} (escape {@dc 16}). The death embrace has six tentacles, each of which can grapple one target.",
        ],
      },
    ],
    reaction: [
      {
        name: "Body Shield",
        entries: [
          "When the death embrace is hit by an attack, one creature the death embrace is grappling (chosen by the death embrace) takes the damage instead.",
        ],
      },
    ],
    traitTags: ["Water Breathing"],
    senseTags: ["B"],
    actionTags: ["Multiattack", "Tentacles"],
    damageTags: ["P", "Y"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["grappled", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dermot Wurder (Tier 1)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 188,
    size: ["S"],
    type: {
      type: "humanoid",
      tags: ["cleric", "goblin", "goblinoid"],
    },
    alignment: ["L", "G"],
    ac: [
      {
        ac: 17,
        from: ["{@item breastplate|PHB}", "{@item shield|PHB}"],
      },
    ],
    hp: {
      average: 44,
      formula: "8d6 + 16",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 12,
    con: 14,
    int: 10,
    wis: 16,
    cha: 10,
    save: {
      wis: "+5",
      cha: "+2",
    },
    skill: {
      medicine: "+5",
      religion: "+2",
      survival: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    languages: ["Common", "Goblin", "Orc"],
    cr: "3",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Dermot casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 13}):",
        ],
        will: [
          "{@spell guidance}",
          "{@spell light}",
          "{@spell spare the dying}",
        ],
        daily: {
          "1e": ["{@spell bless}", "{@spell cure wounds}"],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Dermot makes one Warhammer attack and one Searing Wrath attack.",
        ],
      },
      {
        name: "Warhammer",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d8 + 3}) bludgeoning damage, or 8 ({@damage 1d10 + 3}) bludgeoning damage when used with two hands.",
        ],
      },
      {
        name: "Searing Wrath",
        entries: [
          "{@atk rs} {@hit 5} to hit, range 60 ft., one creature. {@h}9 ({@damage 2d8}) radiant damage, and the target is {@condition blinded} until the end of its next turn.",
        ],
      },
    ],
    attachedItems: ["warhammer|phb"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["B", "R"],
    spellcastingTags: ["O"],
    miscTags: ["MW"],
    conditionInflict: ["blinded"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dermot Wurder (Tier 2)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 191,
    size: ["S"],
    type: {
      type: "humanoid",
      tags: ["cleric", "goblin", "goblinoid"],
    },
    alignment: ["L", "G"],
    ac: [
      {
        ac: 19,
        from: ["splint mail", "{@item shield|PHB}"],
      },
    ],
    hp: {
      average: 82,
      formula: "15d6 + 30",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 12,
    con: 14,
    int: 10,
    wis: 18,
    cha: 10,
    save: {
      wis: "+7",
      cha: "+3",
    },
    skill: {
      medicine: "+7",
      religion: "+3",
      survival: "+7",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    languages: ["Common", "Goblin", "Orc"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Dermot casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 15}):",
        ],
        will: [
          "{@spell guidance}",
          "{@spell light}",
          "{@spell spare the dying}",
        ],
        daily: {
          1: ["{@spell revivify}"],
          "2e": [
            "{@spell bless} (at 2nd level)",
            "{@spell cure wounds} (at 3rd level)",
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Dermot makes one Warhammer attack and one Searing Wrath attack.",
        ],
      },
      {
        name: "Warhammer",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) bludgeoning damage, or 9 ({@damage 1d10 + 4}) bludgeoning damage when used with two hands.",
        ],
      },
      {
        name: "Searing Wrath",
        entries: [
          "{@atk rs} {@hit 7} to hit, range 60 ft., one creature. {@h}18 ({@damage 4d8}) radiant damage, and the target is {@condition blinded} until the end of its next turn.",
        ],
      },
    ],
    attachedItems: ["warhammer|phb"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["B", "R"],
    spellcastingTags: ["O"],
    miscTags: ["MW"],
    conditionInflict: ["blinded"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Dermot Wurder (Tier 3)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 193,
    size: ["S"],
    type: {
      type: "humanoid",
      tags: ["cleric", "goblin", "goblinoid"],
    },
    alignment: ["L", "G"],
    ac: [
      {
        ac: 20,
        from: ["{@item plate armor|PHB|plate}", "{@item shield|PHB}"],
      },
    ],
    hp: {
      average: 93,
      formula: "17d6 + 34",
    },
    speed: {
      walk: 30,
      swim: {
        number: 30,
        condition: "(mariner's armor)",
      },
    },
    str: 18,
    dex: 12,
    con: 14,
    int: 10,
    wis: 20,
    cha: 10,
    save: {
      wis: "+8",
      cha: "+3",
    },
    skill: {
      medicine: "+8",
      religion: "+3",
      survival: "+8",
    },
    senses: ["darkvision 60 ft."],
    passive: 15,
    languages: ["Common", "Goblin", "Orc"],
    cr: "8",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Dermot casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 16}):",
        ],
        will: [
          "{@spell guidance}",
          "{@spell light}",
          "{@spell spare the dying}",
        ],
        daily: {
          1: ["{@spell revivify}"],
          "2e": [
            "{@spell bless} (at 3rd level)",
            "{@spell cure wounds} (at 3rd level)",
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Special Equipment",
        entries: [
          "Dermot wears mariner's armor and wields a ruidium warhammer (see appendix B). If Dermot rolls a 1 on an attack roll made with the warhammer, he must succeed on a {@dc 20} Charisma saving throw or gain 1 level of {@condition exhaustion}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Dermot makes one Ruidium Warhammer attack and one Searing Wrath attack.",
        ],
      },
      {
        name: "Ruidium Warhammer",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) bludgeoning damage, or 9 ({@damage 1d10 + 4}) bludgeoning damage when used with two hands, plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
      {
        name: "Searing Wrath",
        entries: [
          "{@atk rs} {@hit 8} to hit, range 60 ft., one creature. {@h}22 ({@damage 5d8}) radiant damage, and the target is {@condition blinded} until the end of its next turn.",
        ],
      },
    ],
    attachedItems: ["ruidium warhammer|crcotn"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["B", "R", "Y"],
    spellcastingTags: ["O"],
    miscTags: ["MW"],
    conditionInflict: ["blinded", "exhaustion"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Fiendish Orc",
    source: "CRCotN",
    page: 71,
    _copy: {
      name: "Orc War Chief",
      source: "MM",
    },
    type: {
      type: "fiend",
      tags: ["orc"],
    },
    immune: ["fire", "poison"],
    languages: ["Abyssal", "Common", "Orc"],
    hasToken: true,
  },
  {
    name: "Foghome",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 58,
    _copy: {
      name: "Priest",
      source: "MM",
      _trait: {
        name: "Firbolg",
        source: "VGM",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the priest",
          with: "Foghome",
          flags: "i",
        },
      },
    },
    alignment: ["N", "G"],
    spellcastingTags: ["CC", "I"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Galeokaerda",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 130,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["elf", "sorcerer"],
    },
    alignment: ["N", "E"],
    ac: [12],
    hp: {
      average: 91,
      formula: "14d8 + 28",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 15,
    con: 14,
    int: 16,
    wis: 15,
    cha: 18,
    save: {
      wis: "+5",
      cha: "+7",
    },
    skill: {
      arcana: "+6",
      deception: "+7",
      history: "+9",
      perception: "+5",
      stealth: "+8",
    },
    senses: ["darkvision 60 ft."],
    passive: 15,
    resist: ["psychic"],
    languages: ["Celestial", "Common", "Elvish"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The extollant casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 15}):",
        ],
        will: ["{@spell minor illusion}"],
        daily: {
          "1e": [
            "{@spell mage armor}",
            "{@spell major image}",
            "{@spell phantasmal force}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Fey Ancestry",
        entries: [
          "Galeokaerda has advantage on saving throws against being {@condition charmed}, and magic can't put her to sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The extollant makes two Crimson Bolt attacks."],
      },
      {
        name: "Crimson Bolt",
        entries: [
          "{@atk ms,rs} {@hit 7} to hit, reach 5 ft. or range 60 ft., one creature. {@h}20 ({@damage 3d10 + 4}) psychic damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Reflect Agony",
        entries: [
          "When the extollant is damaged by a creature within 60 feet of it, the creature must make a {@dc 15} Wisdom saving throw, taking 16 ({@damage 3d10}) psychic damage on a failed saving throw, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Fey Ancestry"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CE", "E"],
    damageTags: ["Y"],
    damageTagsSpell: ["Y"],
    spellcastingTags: ["O"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Galsariad Ardyth (Tier 1)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 188,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["drow", "elf", "wizard"],
    },
    alignment: ["N"],
    ac: [12],
    hp: {
      average: 49,
      formula: "14d8 - 14",
    },
    speed: {
      walk: 30,
    },
    str: 8,
    dex: 14,
    con: 8,
    int: 16,
    wis: 15,
    cha: 12,
    save: {
      int: "+5",
      wis: "+4",
    },
    skill: {
      arcana: "+5",
      investigation: "+5",
      nature: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 12,
    languages: ["Common", "Draconic", "Undercommon"],
    cr: "3",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Galsariad casts one of the following spells, using Intelligence as the spellcasting ability (spell save {@dc 13}):",
        ],
        will: ["{@spell mage armor}", "{@spell mage hand}"],
        daily: {
          1: ["{@spell longstrider}"],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Fey Ancestry",
        entries: [
          "Galsariad has advantage on saving throws against being {@condition charmed}, and magic can't put him to sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Drain Potential",
        entries: [
          "{@atk ms,rs} {@hit 5} to hit, reach 5 ft. or range 30 ft., one creature. {@h}16 ({@damage 3d10}) necrotic damage, and Galsariad gains 5 temporary hit points.",
        ],
      },
      {
        name: "Gravity Wave {@recharge 5}",
        entries: [
          "Galsariad causes a rippling wave of magical gravity to fill a 10-foot-radius sphere centered on a point he can see within 120 feet of himself. Each creature in that area must make a {@dc 13} Strength saving throw. On a failed saving throw, the creature takes 17 ({@damage 5d6}) force damage and is pulled up to 10 feet toward the sphere's center. On a successful save, the creature takes half as much damage and isn't pulled.",
        ],
      },
    ],
    bonus: [
      {
        name: "Distort Gravity (1/Day)",
        entries: [
          "Galsariad targets himself or one willing creature that he can see within 60 feet of himself, magically distorting gravity around the target. Any creature within 5 feet of the target takes 3 ({@damage 1d6}) force damage. In addition, the target can use a reaction to float upward, up to 20 feet, without provoking opportunity attacks. When this effect ends at the start of Galsariad's next turn, the target floats gently down up to 20 feet.",
        ],
      },
    ],
    traitTags: ["Fey Ancestry"],
    senseTags: ["SD"],
    languageTags: ["C", "DR", "U"],
    damageTags: ["N", "O"],
    spellcastingTags: ["O"],
    miscTags: ["AOE"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Galsariad Ardyth (Tier 2)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 190,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["drow", "elf", "wizard"],
    },
    alignment: ["N"],
    ac: [12],
    hp: {
      average: 67,
      formula: "15d8",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 8,
    dex: 14,
    con: 10,
    int: 18,
    wis: 15,
    cha: 12,
    save: {
      int: "+7",
      wis: "+5",
    },
    skill: {
      arcana: "+7",
      investigation: "+7",
      nature: "+7",
    },
    senses: ["darkvision 120 ft."],
    passive: 12,
    languages: ["Common", "Draconic", "Undercommon"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Galsariad casts one of the following spells, using Intelligence as the spellcasting ability (spell save {@dc 15}):",
        ],
        will: ["{@spell mage armor}", "{@spell mage hand}"],
        daily: {
          "1e": [
            "{@spell longstrider}",
            "{@spell scrying} (as an action)",
            "{@spell slow}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Fey Ancestry",
        entries: [
          "Galsariad has advantage on saving throws against being {@condition charmed}, and magic can't put him to sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Drain Potential",
        entries: [
          "{@atk ms,rs} {@hit 7} to hit, reach 5 ft. or range 60 ft., one creature. {@h}22 ({@damage 4d10}) necrotic damage, and Galsariad gains 5 temporary hit points.",
        ],
      },
      {
        name: "Gravity Wave {@recharge 5}",
        entries: [
          "Galsariad causes a rippling wave of magical gravity to fill a 20-foot-radius sphere centered on a point he can see within 100 feet of himself. Each creature in that area must make a {@dc 15} Strength saving throw. On a failed saving throw, the creature takes 35 ({@damage 10d6}) force damage and is pulled up to 20 feet toward the sphere's center, and is knocked {@condition prone}. On a successful save, the creature takes half as much damage and isn't pulled or knocked {@condition prone}.",
        ],
      },
    ],
    bonus: [
      {
        name: "Distort Gravity (1/Day)",
        entries: [
          "Galsariad targets himself or one willing creature that he can see within 60 feet of himself, magically distorting gravity around the target. Any creature within 5 feet of the target takes 7 ({@damage 2d6}) force damage. In addition, the target can use a reaction to float upward, up to 20 feet, without provoking opportunity attacks. When this effect ends at the start of Galsariad's next turn, the target floats gently down up to 20 feet.",
        ],
      },
    ],
    traitTags: ["Fey Ancestry"],
    senseTags: ["SD"],
    languageTags: ["C", "DR", "U"],
    damageTags: ["N", "O"],
    spellcastingTags: ["O"],
    miscTags: ["AOE"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Galsariad Ardyth (Tier 3)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 193,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["drow", "elf", "wizard"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 17,
        from: ["deflection"],
      },
    ],
    hp: {
      average: 90,
      formula: "20d8",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      swim: {
        number: 40,
        condition: "(ring of swimming)",
      },
      canHover: true,
    },
    str: 8,
    dex: 14,
    con: 10,
    int: 20,
    wis: 15,
    cha: 12,
    save: {
      int: "+8",
      wis: "+5",
    },
    skill: {
      arcana: "+8",
      investigation: "+8",
      nature: "+8",
    },
    senses: ["darkvision 120 ft."],
    passive: 12,
    languages: ["Common", "Draconic", "Undercommon"],
    cr: "8",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Galsariad casts one of the following spells, using Intelligence as the spellcasting ability (spell save {@dc 16}):",
        ],
        will: ["{@spell mage hand}"],
        daily: {
          "1e": [
            "{@spell longstrider}",
            "{@spell scrying} (as an action)",
            "{@spell slow}",
            "{@spell telekinesis}",
            "{@spell water breathing}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Deflection",
        entries: [
          "Galsariad warps gravity around himself to magically deflect incoming attacks. While Galsariad is wearing no armor and not {@condition incapacitated}, his AC includes his Intelligence modifier.",
        ],
      },
      {
        name: "Fey Ancestry",
        entries: [
          "Galsariad has advantage on saving throws against being {@condition charmed}, and magic can't put him to sleep.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Galsariad wears a ring of swimming and carries a ruidium dagger (see appendix B). If he rolls a 1 on an attack roll made with the dagger, he must succeed on a {@dc 20} Charisma saving throw or gain 1 level of {@condition exhaustion}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Galsariad makes one Drain Potential attack and one Ruidium Dagger attack.",
        ],
      },
      {
        name: "Drain Potential",
        entries: [
          "{@atk ms,rs} {@hit 8} to hit, reach 5 ft. or range 120 ft., one creature. {@h}22 ({@damage 4d10}) necrotic damage, and Galsariad gains 10 temporary hit points.",
        ],
      },
      {
        name: "Ruidium Dagger",
        entries: [
          "{@atk mw,rw} {@hit 5} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
      {
        name: "Gravity Wave {@recharge 5}",
        entries: [
          "Galsariad causes a rippling wave of magical gravity to fill a 30-foot-radius sphere centered on a point he can see within 100 feet of himself. Each creature in that area must make a {@dc 16} Strength saving throw. On a failed saving throw, the creature takes 42 ({@damage 12d6}) force damage and is {@condition restrained} for 1 minute. On a successful save, the creature takes half as much damage and isn't {@condition restrained}. A {@condition restrained} creature can repeat the save at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    bonus: [
      {
        name: "Distort Gravity (1/Day)",
        entries: [
          "Galsariad targets himself or one willing creature that he can see within 60 feet of himself, magically distorting gravity around the target. Any creature within 5 feet of the target takes 14 ({@damage 4d6}) force damage. In addition, the target can use a reaction to float upward, up to 20 feet, without provoking opportunity attacks. When this effect ends at the start of Galsariad's next turn, the target floats gently down up to 20 feet.",
        ],
      },
    ],
    attachedItems: ["ruidium dagger|crcotn"],
    traitTags: ["Fey Ancestry"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "U"],
    damageTags: ["N", "O", "P", "Y"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    conditionInflict: ["exhaustion", "restrained"],
    conditionInflictSpell: ["restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Gryz Alakritos",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 81,
    _copy: {
      name: "Scholarly Mastermind",
      source: "CRCotN",
      _trait: {
        name: "Goblin",
        source: "DMG",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the mastermind",
          with: "Gryz",
          flags: "i",
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["goblin", "wizard"],
    },
    alignment: ["N", "G"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Insight Acuere",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 126,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["wizard"],
    },
    alignment: ["L", "G"],
    ac: [12],
    hp: {
      average: 82,
      formula: "15d8 + 15",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 13,
    int: 18,
    wis: 16,
    cha: 14,
    save: {
      int: "+7",
      wis: "+6",
    },
    skill: {
      arcana: "+7",
      history: "+7",
      insight: "+6",
      perception: "+6",
    },
    senses: ["darkvision 60 ft."],
    passive: 16,
    resist: ["fire"],
    languages: ["Aquan", "Common", "Infernal", "Orc"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Insight casts one of the following spells, requiring no material components and using Intelligence as the spellcasting ability (spell save {@dc 15}):",
        ],
        will: ["{@spell alter self}", "{@spell light}", "{@spell mage hand}"],
        daily: {
          "1e": [
            "{@spell comprehend languages}",
            "{@spell mage armor}",
            "{@spell zone of truth}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Insight makes two Arcane Shock or Dagger of the Poisoned Mind attacks.",
        ],
      },
      {
        name: "Arcane Shock",
        entries: [
          "{@atk ms,rs} {@hit 7} to hit, reach 5 ft. or range 60 ft., one target. {@h}26 ({@damage 4d10 + 4}) lightning damage. If the target is a creature, it can't take reactions until the start of its next turn.",
        ],
      },
      {
        name: "Dagger of the Poisoned Mind",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage plus 10 ({@damage 3d6}) psychic damage. If the target is a creature, it must succeed on a {@dc 15} Wisdom saving throw or be {@condition frightened} until the end of its next turn.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["AQ", "C", "I", "O"],
    damageTags: ["L", "P", "Y"],
    damageTagsSpell: ["B", "P", "S"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["frightened"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Irvan Wastewalker (Tier 1)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 189,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "N"],
    ac: [
      {
        ac: 13,
        from: ["{@item leather armor|PHB}"],
      },
    ],
    hp: {
      average: 66,
      formula: "12d8 + 12",
    },
    speed: {
      walk: 30,
    },
    str: 8,
    dex: 14,
    con: 12,
    int: 12,
    wis: 12,
    cha: 12,
    save: {
      dex: "+4",
      con: "+3",
    },
    skill: {
      acrobatics: "+4",
      deception: "+3",
      stealth: "+6",
      survival: "+3",
    },
    passive: 11,
    languages: ["Common", "Goblin"],
    cr: "3",
    trait: [
      {
        name: "Fortitude (Recharges after a Short or Long Rest)",
        entries: [
          "If damage reduces Irvan to 0 hit points, he can make a Constitution saving throw with a DC equal to 5 + the damage taken. On a successful save, Irvan drops to 1 hit point instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Irvan makes two Dagger attacks."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 4} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage plus 7 ({@damage 2d6}) poison damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO"],
    damageTags: ["I", "P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Irvan Wastewalker (Tier 2)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 191,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "N"],
    ac: [
      {
        ac: 15,
        from: ["{@item studded leather armor|PHB|studded leather}"],
      },
    ],
    hp: {
      average: 99,
      formula: "18d8 + 18",
    },
    speed: {
      walk: 40,
    },
    str: 10,
    dex: 16,
    con: 12,
    int: 14,
    wis: 14,
    cha: 14,
    save: {
      dex: "+6",
      con: "+4",
    },
    skill: {
      acrobatics: "+6",
      deception: "+5",
      stealth: "+9",
      survival: "+5",
    },
    passive: 12,
    languages: ["Common", "Goblin"],
    cr: "5",
    trait: [
      {
        name: "Fortitude (Recharges after a Short or Long Rest)",
        entries: [
          "If damage reduces Irvan to 0 hit points, he can make a Constitution saving throw with a DC equal to 5 + the damage taken. On a successful save, Irvan drops to 1 hit point instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Irvan makes two Dagger attacks."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 6} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}5 ({@damage 1d4 + 3}) piercing damage plus 14 ({@damage 4d6}) poison damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO"],
    damageTags: ["I", "P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Irvan Wastewalker (Tier 3)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 194,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "N"],
    ac: [
      {
        ac: 17,
        from: ["{@item studded leather armor|PHB|studded leather}"],
      },
    ],
    hp: {
      average: 123,
      formula: "19d8 + 38",
    },
    speed: {
      walk: 40,
      swim: {
        number: 40,
        condition: "(see special equipment)",
      },
    },
    str: 10,
    dex: 20,
    con: 14,
    int: 16,
    wis: 16,
    cha: 16,
    save: {
      dex: "+8",
      con: "+5",
    },
    skill: {
      acrobatics: "+8",
      deception: "+9",
      stealth: "+11",
      survival: "+6",
    },
    passive: 13,
    languages: ["Common", "Goblin", "Orc"],
    cr: "8",
    trait: [
      {
        name: "Fortitude (Recharges after a Short or Long Rest)",
        entries: [
          "If damage reduces Irvan to 0 hit points, he can make a Constitution saving throw with a DC equal to 5 + the damage taken. On a successful save, Irvan drops to 1 hit point instead.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Irvan wears gloves of swimming and climbing and wields a ruidium shortsword (see appendix B). If Irvan rolls a 1 on an attack roll made with the shortsword, he must succeed on a {@dc 20} Charisma saving throw or gain 1 level of {@condition exhaustion}.",
          "In addition, Irvan has a magical prosthetic arm. While the arm is attached to him, it functions the same as the body part it is replacing. Irvan can attach or detach the arm as an action, and it can't be removed by anyone else.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Irvan makes one Dagger attack and two Ruidium Shortsword attacks.",
        ],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 8} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d4 + 5}) piercing damage plus 17 ({@damage 5d6}) poison damage.",
        ],
      },
      {
        name: "Ruidium Shortsword",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d6 + 5}) piercing damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb", "ruidium shortsword|crcotn"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GO", "O"],
    damageTags: ["I", "P", "Y"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["exhaustion"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "James Cryon",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 81,
    _copy: {
      name: "Scholarly Mastermind",
      source: "CRCotN",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the mastermind",
          with: "James",
          flags: "i",
        },
      },
    },
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["elf", "wizard"],
    },
    alignment: ["L", "N"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Jamil A'alithiya",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 83,
    _copy: {
      name: "Monastic High Curator",
      source: "CRCotN",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the high curator",
          with: "Jamil",
          flags: "i",
        },
      },
    },
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human", "monk", "wizard"],
    },
    alignment: ["C", "G"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Koris",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 106,
    _copy: {
      name: "Assassin",
      source: "MM",
      _trait: {
        name: "Tiefling",
        source: "PHB",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the assassin",
          with: "Koris",
          flags: "i",
        },
      },
    },
    size: ["M"],
    alignment: ["L", "N"],
    damageTagsSpell: ["F"],
    spellcastingTags: ["I"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Laurin Ophidas",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 112,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["half-elf"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 13,
        from: ["{@item leather armor|PHB}"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 30,
    },
    str: 11,
    dex: 14,
    con: 12,
    int: 10,
    wis: 13,
    cha: 14,
    skill: {
      deception: "+4",
      persuasion: "+4",
      religion: "+2",
    },
    passive: 11,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["Any one language (usually Common)"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The fanatic is a 4th-level spellcaster. Its spellcasting ability is Wisdom (spell save {@dc 11}, {@hit 3} to hit with spell attacks). The fanatic has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{@spell light}",
              "{@spell sacred flame}",
              "{@spell thaumaturgy}",
            ],
          },
          1: {
            slots: 4,
            spells: [
              "{@spell command}",
              "{@spell inflict wounds}",
              "{@spell shield of faith}",
            ],
          },
          2: {
            slots: 3,
            spells: ["{@spell hold person}", "{@spell spiritual weapon}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Dark Devotion",
        entries: [
          "The fanatic has advantage on saving throws against being {@condition charmed} or {@condition frightened}.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Laurin wields a staff of the adder and is attuned to it as though he were a cleric.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The fanatic makes two melee attacks."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 4} to hit, reach 5 ft. or range 20/60 ft., one creature. {@h}4 ({@damage 1d4 + 2}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["P"],
    damageTagsSpell: ["N", "O", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflictSpell: ["paralyzed", "prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Light Devourer",
    source: "CRCotN",
    page: 200,
    size: ["M"],
    type: "aberration",
    alignment: ["U"],
    ac: [14],
    hp: {
      average: 119,
      formula: "14d8 + 56",
    },
    speed: {
      walk: 0,
      swim: 30,
    },
    str: 18,
    dex: 18,
    con: 18,
    int: 2,
    wis: 10,
    cha: 3,
    skill: {
      perception: "+3",
      stealth: "+10",
    },
    senses: ["darkvision 120 ft."],
    passive: 13,
    immune: ["radiant"],
    cr: "6",
    trait: [
      {
        name: "Light Absorption",
        entries: [
          "If the light devourer spends any part of its turn in an area of bright light or is subjected to radiant damage, it radiates dim light in a 10-foot radius for 1 hour.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The light devourer can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The light devourer makes two Bite attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}21 ({@damage 5d6 + 4}) piercing damage, or radiant damage if the light devourer is radiating light (see Light Absorption).",
        ],
      },
    ],
    bonus: [
      {
        name: "Radiant Discharge",
        entries: [
          "If the light devourer is radiating light (see Light Absorption), it releases the light stored in its body in a 20-foot-radius sphere centered on itself, then ceases to radiate light. Each creature in the sphere must make a {@dc 15} Constitution saving throw, taking 24 ({@damage 7d6}) radiant damage on a failed saving throw, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Damage Absorption", "Water Breathing"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    damageTags: ["P", "R"],
    miscTags: ["AOE", "MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Maggie Keeneyes (Tier 1)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 189,
    size: ["L"],
    type: {
      type: "giant",
      tags: ["ogre"],
    },
    alignment: ["L", "N"],
    ac: [
      {
        ac: 13,
        from: ["{@item leather armor|PHB}"],
      },
    ],
    hp: {
      average: 85,
      formula: "10d10 + 30",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 14,
    con: 16,
    int: 14,
    wis: 14,
    cha: 8,
    save: {
      str: "+6",
      con: "+5",
    },
    skill: {
      athletics: "+6",
      insight: "+4",
      perception: "+4",
      persuasion: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    languages: ["Common", "Giant"],
    cr: "3",
    trait: [
      {
        name: "Tactical Readiness",
        entries: [
          "Maggie and allies within 30 feet of her have advantage on initiative rolls, as long as Maggie isn't {@condition incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Giant Maul",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 10 ft., one target. {@h}13 ({@damage 2d8 + 4}) bludgeoning damage, and if the target is a creature, Maggie can force it to make a {@dc 14} Strength saving throw; on a failed save, the target is pushed 5 feet away from Maggie and knocked {@condition prone}.",
        ],
      },
      {
        name: "Hammer Toss",
        entries: [
          "{@atk rw} {@hit 6} to hit, range 20/60 ft., one target. {@h}9 ({@damage 2d4 + 4}) bludgeoning damage, and if the target is a creature, Maggie can force it to make a {@dc 14} Strength saving throw; on a failed save, the target is pushed 5 feet away from Maggie and knocked {@condition prone}.",
        ],
      },
    ],
    senseTags: ["D"],
    languageTags: ["C", "GI"],
    damageTags: ["B"],
    miscTags: ["MW", "RCH", "RW"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Maggie Keeneyes (Tier 2)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 191,
    size: ["L"],
    type: {
      type: "giant",
      tags: ["ogre"],
    },
    alignment: ["L", "N"],
    ac: [
      {
        ac: 15,
        from: ["{@item chain shirt|phb}"],
      },
    ],
    hp: {
      average: 114,
      formula: "12d10 + 48",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 18,
    dex: 14,
    con: 18,
    int: 14,
    wis: 16,
    cha: 8,
    save: {
      str: "+7",
      con: "+7",
    },
    skill: {
      athletics: "+7",
      insight: "+6",
      perception: "+6",
      persuasion: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 16,
    conditionImmune: ["frightened"],
    languages: ["Common", "Giant"],
    cr: "5",
    trait: [
      {
        name: "Push",
        entries: [
          "Once during each of her turns, after hitting a creature with an attack, Maggie can force the target to make a {@dc 15} Strength saving throw; on a failed save, the target is pushed up to 10 feet horizontally away from Maggie and knocked {@condition prone}.",
        ],
      },
      {
        name: "Tactical Readiness",
        entries: [
          "Maggie and allies within 30 feet of her have advantage on initiative rolls, as long as Maggie isn't {@condition incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Maggie makes two Giant Maul or Hammer Toss attacks."],
      },
      {
        name: "Giant Maul",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}13 ({@damage 2d8 + 4}) bludgeoning damage.",
        ],
      },
      {
        name: "Hammer Toss",
        entries: [
          "{@atk rw} {@hit 7} to hit, range 20/60 ft., one target. {@h}9 ({@damage 2d4 + 4}) bludgeoning damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Rally (1/Day)",
        entries: [
          "Maggie targets one creature she can see within 30 feet of herself and bolsters it with words of encouragement. The target gains 15 temporary hit points if it can see or hear Maggie.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GI"],
    damageTags: ["B"],
    miscTags: ["MW", "RCH", "RW"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Maggie Keeneyes (Tier 3)",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 194,
    size: ["L"],
    type: {
      type: "giant",
      tags: ["ogre"],
    },
    alignment: ["L", "N"],
    ac: [
      {
        ac: 18,
        from: ["{@item plate armor|PHB|plate}"],
      },
    ],
    hp: {
      average: 142,
      formula: "15d10 + 60",
    },
    speed: {
      walk: 30,
      swim: {
        number: 30,
        condition: "(ruidium armor)",
      },
    },
    str: 20,
    dex: 14,
    con: 18,
    int: 14,
    wis: 14,
    cha: 8,
    save: {
      str: "+8",
      con: "+7",
    },
    skill: {
      athletics: "+8",
      insight: "+5",
      perception: "+5",
      persuasion: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 16,
    resist: [
      {
        resist: ["psychic"],
        note: "(granted by ruidium armor)",
      },
    ],
    conditionImmune: ["charmed", "frightened"],
    languages: ["Common", "Giant"],
    cr: "8",
    trait: [
      {
        name: "Push",
        entries: [
          "Once during each of her turns, after hitting a creature with an attack, Maggie can force the target to make a {@dc 16} Strength saving throw; on a failed save, the target is pushed up to 15 feet horizontally away from Maggie and knocked {@condition prone}.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Maggie wears a suit of ruidium armor (plate; see appendix B). If Maggie rolls a 1 on a saving throw while wearing the armor, she must succeed on a {@dc 20} Charisma saving throw or gain 1 level of {@condition exhaustion}.",
        ],
      },
      {
        name: "Tactical Readiness",
        entries: [
          "Maggie and allies within 30 feet of her have advantage on initiative rolls, as long as Maggie isn't {@condition incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Maggie makes two Heavy Greataxe or Hammer Toss attacks."],
      },
      {
        name: "Heavy Greataxe",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d12 + 5}) slashing damage.",
        ],
      },
      {
        name: "Hammer Toss",
        entries: [
          "{@atk rw} {@hit 8} to hit, range 20/60 ft., one target. {@h}15 ({@damage 4d4 + 5}) bludgeoning damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Rally (1/Day)",
        entries: [
          "Maggie targets one creature she can see within 60 feet of herself and bolsters it with words of encouragement. The target gains 30 temporary hit points if it can see or hear Maggie.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GI"],
    damageTags: ["B", "S"],
    miscTags: ["MW", "RCH", "RW"],
    conditionInflict: ["exhaustion", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Marisa",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 150,
    _copy: {
      name: "Ghost",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the ghost",
          with: "Marisa",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Meri",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 150,
    _copy: {
      name: "Ghost",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the ghost",
          with: "Meri",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Monastic High Curator",
    source: "CRCotN",
    page: 201,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["monk", "wizard"],
    },
    alignment: ["A"],
    ac: [
      {
        ac: 19,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 130,
      formula: "20d8 + 40",
    },
    speed: {
      walk: 60,
    },
    str: 12,
    dex: 16,
    con: 14,
    int: 18,
    wis: 22,
    cha: 17,
    save: {
      dex: "+7",
      wis: "+10",
    },
    skill: {
      arcana: "+8",
      history: "+8",
      investigation: "+8",
      perception: "+10",
    },
    senses: ["blindsight 30 ft."],
    passive: 20,
    resist: ["psychic"],
    conditionImmune: ["charmed"],
    languages: ["Common plus four other languages"],
    cr: "10",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The high curator casts one of the following spells, requiring no material components and using Wisdom as the spellcasting ability (spell save {@dc 18}):",
        ],
        will: ["{@spell detect magic}"],
        daily: {
          "2e": [
            "{@spell detect thoughts}",
            "{@spell identify} (as an action)",
            "{@spell scrying} (as an action)",
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Unarmored Defense",
        entries: [
          "While the high curator is wearing no armor and wielding no shield, its AC includes its Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The high curator makes three Force Strike attacks and uses Brain Burn (if available).",
        ],
      },
      {
        name: "Force Strike",
        entries: [
          "{@atk ms,rs} {@hit 10} to hit, reach 5 ft. or range 10 ft., one target. {@h}17 ({@damage 2d10 + 6}) force damage.",
        ],
      },
      {
        name: "Brain Burn {@recharge 4}",
        entries: [
          "The high curator targets up to two creatures it can see within 30 feet of itself. Each target must make a {@dc 18} Constitution saving throw. On a failed saving throw, the target takes 28 ({@damage 8d6}) psychic damage and can't take reactions until the start of its next turn. On a successful save, the target takes half as much damage and suffers no other effect.",
        ],
      },
    ],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["O", "Y"],
    spellcastingTags: ["O"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Monastic Infiltrator",
    source: "CRCotN",
    page: 202,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["monk"],
    },
    alignment: ["A"],
    ac: [
      {
        ac: 18,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 112,
      formula: "15d8 + 45",
    },
    speed: {
      walk: 50,
    },
    str: 13,
    dex: 20,
    con: 16,
    int: 15,
    wis: 17,
    cha: 16,
    save: {
      dex: "+8",
      wis: "+6",
    },
    skill: {
      acrobatics: "+8",
      deception: "+9",
      perception: "+6",
      stealth: "+11",
    },
    passive: 16,
    resist: ["psychic"],
    conditionImmune: ["charmed"],
    languages: ["Common plus three other languages"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The infiltrator casts one of the following spells, requiring no material components and using Wisdom as the spellcasting ability (spell save {@dc 14}):",
        ],
        will: ["{@spell disguise self}"],
        daily: {
          "2e": ["{@spell detect thoughts}", "{@spell invisibility}"],
          "1e": ["{@spell dimension door}", "{@spell zone of truth}"],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Guarded Mind",
        entries: [
          "Spells and other effects can't read the infiltrator's thoughts or determine if the infiltrator is lying. Creatures can communicate telepathically with the infiltrator only if it allows such contact.",
        ],
      },
      {
        name: "Unarmored Defense",
        entries: [
          "While the infiltrator is wearing no armor and wielding no shield, its AC includes its Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The infiltrator makes three Unarmed Strike attacks."],
      },
      {
        name: "Unarmed Strike",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}10 ({@damage 1d10 + 5}) force damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Cunning Action",
        entries: ["The infiltrator takes the Dash or Disengage action."],
      },
    ],
    reaction: [
      {
        name: "Retaliating Strike",
        entries: [
          "When a creature within 5 feet of the infiltrator hits or misses the infiltrator with a melee attack, the infiltrator makes one Unarmed Strike attack against the attacker.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["O"],
    damageTagsSpell: ["O"],
    spellcastingTags: ["O"],
    miscTags: ["MW"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Monastic Operative",
    source: "CRCotN",
    page: 202,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["monk"],
    },
    alignment: ["A"],
    ac: [
      {
        ac: 17,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 84,
      formula: "13d8 + 26",
    },
    speed: {
      walk: 40,
    },
    str: 13,
    dex: 18,
    con: 14,
    int: 14,
    wis: 17,
    cha: 11,
    save: {
      dex: "+7",
      wis: "+6",
    },
    skill: {
      acrobatics: "+7",
      insight: "+6",
      investigation: "+8",
      stealth: "+7",
    },
    passive: 13,
    languages: ["Common plus two other languages"],
    cr: "5",
    trait: [
      {
        name: "Unarmored Defense",
        entries: [
          "While the operative is wearing no armor and wielding no shield, its AC includes its Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The operative makes three Unarmed Strike attacks, three Cobalt Dart attacks, or a combination thereof.",
        ],
      },
      {
        name: "Unarmed Strike",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}9 ({@damage 1d10 + 4}) bludgeoning damage.",
        ],
      },
      {
        name: "Cobalt Dart",
        entries: [
          "{@atk rw} {@hit 7} to hit, range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage plus 3 ({@damage 1d6}) force damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Retaliating Strike",
        entries: [
          "When a creature within 5 feet of the operative hits or misses the operative with a melee attack, the operative makes one Unarmed Strike attack against the attacker.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["C", "X"],
    damageTags: ["B", "O", "P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Moonshark",
    source: "CRCotN",
    page: 33,
    _copy: {
      name: "Giant Shark",
      source: "MM",
      _mod: {
        trait: {
          mode: "appendArr",
          items: {
            name: "Silver Spear",
            entries: [
              "A character within 5 feet of the shark can use an action to try to dislodge the spear, doing so with a successful {@dc 13} Strength (Athletics) check. While the spear is lodged in the shark, the shark glows with silvery illumination, shedding bright light in a 10-foot radius and dim light for an additional 10 feet.",
            ],
          },
        },
      },
    },
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}22 ({@damage 3d10 + 6}) piercing damage. If the shark misses, it can use a bonus action to swim up to 25 feet. This movement doesn't provoke opportunity attacks.",
        ],
      },
    ],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Occult Extollant",
    source: "CRCotN",
    page: 204,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["sorcerer"],
    },
    alignment: ["A"],
    ac: [12],
    hp: {
      average: 91,
      formula: "14d8 + 28",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 15,
    con: 14,
    int: 16,
    wis: 15,
    cha: 18,
    save: {
      wis: "+5",
      cha: "+7",
    },
    skill: {
      arcana: "+6",
      deception: "+7",
      history: "+9",
      perception: "+5",
      stealth: "+8",
    },
    senses: ["darkvision 60 ft."],
    passive: 15,
    resist: ["psychic"],
    languages: ["Common plus two other languages"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The extollant casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 15}):",
        ],
        will: ["{@spell minor illusion}"],
        daily: {
          "1e": [
            "{@spell mage armor}",
            "{@spell major image}",
            "{@spell phantasmal force}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The extollant makes two Crimson Bolt attacks."],
      },
      {
        name: "Crimson Bolt",
        entries: [
          "{@atk ms,rs} {@hit 7} to hit, reach 5 ft. or range 60 ft., one creature. {@h}20 ({@damage 3d10 + 4}) psychic damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Reflect Agony",
        entries: [
          "When the extollant is damaged by a creature within 60 feet of it, the creature must make a {@dc 15} Wisdom saving throw, taking 16 ({@damage 3d10}) psychic damage on a failed saving throw, or half as much damage on a successful one.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "X"],
    damageTags: ["Y"],
    damageTagsSpell: ["Y"],
    spellcastingTags: ["O"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Occult Initiate",
    source: "CRCotN",
    page: 205,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["sorcerer"],
    },
    alignment: ["A"],
    ac: [12],
    hp: {
      average: 66,
      formula: "12d8 + 12",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 12,
    int: 14,
    wis: 10,
    cha: 16,
    skill: {
      arcana: "+6",
      deception: "+5",
      history: "+4",
      perception: "+2",
    },
    passive: 12,
    languages: ["Common plus one other language"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The initiate casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 13}):",
        ],
        will: ["{@spell light}", "{@spell mage hand}"],
        daily: {
          "1e": ["{@spell detect magic}", "{@spell levitate}"],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Shortsword",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d6 + 2}) piercing damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
      {
        name: "Arcane Blast {@recharge 5}",
        entries: [
          "The initiate creates an explosion of magical force in a 20-foot-radius sphere centered on a point it can see within 120 feet of itself. Each creature in that area must make a {@dc 13} Dexterity saving throw. On a failed saving throw, the creature takes 10 ({@damage 3d6}) force damage and is pushed 10 feet away from the center of the area. On a successful save, it takes half as much damage and isn't pushed.",
        ],
      },
    ],
    attachedItems: ["shortsword|phb"],
    languageTags: ["C", "X"],
    damageTags: ["O", "P", "Y"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Occult Silvertongue",
    source: "CRCotN",
    page: 205,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["sorcerer"],
    },
    alignment: ["L", "E"],
    alignmentPrefix: "typically ",
    ac: [13],
    hp: {
      average: 127,
      formula: "17d8 + 51",
    },
    speed: {
      walk: 40,
    },
    str: 13,
    dex: 16,
    con: 16,
    int: 15,
    wis: 17,
    cha: 20,
    save: {
      wis: "+6",
      cha: "+8",
    },
    skill: {
      arcana: "+8",
      deception: "+11",
      history: "+5",
      perception: "+6",
    },
    senses: ["truesight 60 ft."],
    passive: 16,
    resist: ["psychic"],
    languages: ["Common plus three other languages", "telepathy 60 ft."],
    cr: "8",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The silvertongue casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 16}):",
        ],
        daily: {
          1: ["{@spell dimension door}"],
          "2e": [
            "{@spell charm person}",
            "{@spell mage armor}",
            "{@spell sending}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Alien Mind",
        entries: [
          "If a creature tries to read the silvertongue's thoughts or deals psychic damage to the silvertongue, that creature must succeed on a {@dc 16} Intelligence saving throw or be {@condition stunned} until the start of its next turn.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The silvertongue has advantage on saving throws against spells and other magical effects.",
        ],
      },
    ],
    action: [
      {
        name: "Crimson Bolt",
        entries: [
          "{@atk ms,rs} {@hit 8} to hit, reach 5 ft. or range 60 ft., one creature. {@h}27 ({@damage 4d10 + 5}) psychic damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Elemental Servitor (1/Day)",
        entries: [
          "The silvertongue magically summons an earth elemental, which appears in an unoccupied space the silvertongue can see within 60 feet of itself. The earth elemental takes its turn immediately after the silvertongue on the same initiative count and obeys the silvertongue's commands. The earth elemental disappears after 1 minute or when it or the silvertongue dies.",
        ],
      },
    ],
    traitTags: ["Magic Resistance"],
    senseTags: ["U"],
    languageTags: ["C", "TP"],
    damageTags: ["Y"],
    damageTagsSpell: ["O"],
    spellcastingTags: ["O"],
    conditionInflict: ["stunned"],
    conditionInflictSpell: ["charmed"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Olara",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 129,
    size: ["M"],
    type: "humanoid",
    alignment: ["N", "G"],
    ac: [
      {
        ac: 13,
        from: ["{@item leather armor|PHB}"],
      },
    ],
    hp: {
      average: 16,
      formula: "3d8 + 3",
    },
    speed: {
      walk: 30,
      swim: 30,
    },
    str: 11,
    dex: 14,
    con: 12,
    int: 11,
    wis: 13,
    cha: 11,
    skill: {
      nature: "+4",
      perception: "+5",
      stealth: "+6",
      survival: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 15,
    resist: ["cold"],
    languages: ["Any one language (usually Common)"],
    cr: "1/2",
    trait: [
      {
        name: "Amphibious",
        entries: ["Olara can breathe air and water."],
      },
      {
        name: "Fey Ancestry",
        entries: [
          "Olara has advantage on saving throws to end the {@condition charmed} condition on herself, and magic can't put her to sleep.",
        ],
      },
      {
        name: "Keen Hearing and Sight",
        entries: [
          "The scout has advantage on Wisdom (Perception) checks that rely on hearing or sight.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Olara makes two melee attacks or two ranged attacks."],
      },
      {
        name: "Shortsword",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d6 + 2}) piercing damage.",
        ],
      },
      {
        name: "Longbow",
        entries: [
          "{@atk rw} {@hit 4} to hit, ranged 150/600 ft., one target. {@h}6 ({@damage 1d8 + 2}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["longbow|phb", "shortsword|phb"],
    traitTags: ["Amphibious", "Fey Ancestry", "Keen Senses"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["P"],
    miscTags: ["MW", "RNG", "RW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Perigee",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 168,
    _copy: {
      name: "Deva",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the deva",
          with: "Perigee",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Prolix Yusaf",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 54,
    _copy: {
      name: "Scholarly Agent",
      source: "CRCotN",
      _trait: {
        name: "Tiefling",
        source: "PHB",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the agent",
          with: "Prolix",
          flags: "i",
        },
      },
    },
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["tiefling", "wizard"],
    },
    alignment: ["L", "N"],
    damageTagsSpell: ["F"],
    spellcastingTags: ["I", "O"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Ruidium Elephant",
    source: "CRCotN",
    page: 95,
    size: ["H"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 138,
      formula: "12d12 + 60",
    },
    speed: {
      walk: 40,
    },
    str: 24,
    dex: 9,
    con: 21,
    int: 3,
    wis: 11,
    cha: 6,
    passive: 10,
    conditionImmune: ["charmed", "frightened"],
    cr: "8",
    trait: [
      {
        name: "Trampling Charge",
        entries: [
          "If the elephant moves at least 20 feet straight toward a creature and then hits it with a Gore attack on the same turn, that target must succeed on a {@dc 16} Strength saving throw or be knocked {@condition prone}. If the target is {@condition prone}, the elephant can make one Stomp attack against it as a bonus action.",
        ],
      },
    ],
    action: [
      {
        name: "Gore",
        entries: [
          "{@atk mw} {@hit 10} to hit (with advantage if the target is a creature missing any hit points), reach 10 ft., one target. {@h}25 ({@damage 4d8 + 7}) piercing damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
      {
        name: "Stomp",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one {@condition prone} creature. {@h}29 ({@damage 4d10 + 7}) bludgeoning damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
    ],
    damageTags: ["B", "P", "Y"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Scholarly Agent",
    source: "CRCotN",
    page: 206,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["wizard"],
    },
    alignment: ["A"],
    ac: [11],
    hp: {
      average: 22,
      formula: "4d8 + 4",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 12,
    con: 12,
    int: 16,
    wis: 12,
    cha: 10,
    save: {
      int: "+5",
    },
    skill: {
      arcana: "+5",
      history: "+5",
      investigation: "+5",
    },
    passive: 11,
    languages: ["Common plus one other language"],
    cr: "1",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The agent casts one of the following spells, using Intelligence as the spellcasting ability:",
        ],
        will: ["{@spell dancing lights}", "{@spell mage hand}"],
        daily: {
          "1e": [
            "{@spell comprehend languages}",
            "{@spell identify} (as an action)",
            "{@spell mage armor}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Arcane Shock",
        entries: [
          "{@atk ms,rs} {@hit 5} to hit, reach 5 ft. or range 30 ft., one target. {@h}14 ({@damage 2d10 + 3}) lightning damage. If the target is a creature, it can't take reactions until the start of its next turn.",
        ],
      },
    ],
    reaction: [
      {
        name: "Glyph of Shielding",
        entries: [
          "The agent adds 2 to its AC against one attack that would hit it. To do so, the agent must be able to see the attacker and have a free hand.",
        ],
      },
    ],
    languageTags: ["C", "X"],
    damageTags: ["L"],
    spellcastingTags: ["O"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Scholarly Excavator",
    source: "CRCotN",
    page: 206,
    size: ["S", "M"],
    type: "humanoid",
    alignment: ["A"],
    ac: [
      {
        ac: 16,
        from: ["{@item breastplate|PHB}"],
      },
    ],
    hp: {
      average: 67,
      formula: "9d8 + 27",
    },
    speed: {
      walk: 30,
    },
    str: 15,
    dex: 14,
    con: 16,
    int: 14,
    wis: 14,
    cha: 12,
    save: {
      con: "+5",
      int: "+4",
    },
    skill: {
      arcana: "+4",
      athletics: "+4",
      history: "+4",
    },
    passive: 12,
    languages: ["Common plus two other languages"],
    cr: "3",
    trait: [
      {
        name: "Siege Expert",
        entries: [
          "The excavator deals double damage to objects and structures.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The excavator makes three Thunderous Warhammer attacks."],
      },
      {
        name: "Thunderous Warhammer",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d10 + 2}) thunder damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Telekinetic Toss {@recharge 5}",
        entries: [
          "The excavator targets one Medium or smaller creature or an object weighing 300 pounds or less that isn't being worn or carried. The target, which must be within 30 feet of the excavator and visible to it, is magically pushed up to 20 feet horizontally in a direction of the excavator's choice. If the target is a creature, it can make a {@dc 13} Strength saving throw to resist the effect and is not pushed on a successful save.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["C", "X"],
    damageTags: ["T"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Scholarly Mastermind",
    source: "CRCotN",
    page: 207,
    size: ["S", "M"],
    type: {
      type: "humanoid",
      tags: ["wizard"],
    },
    alignment: ["A"],
    ac: [12],
    hp: {
      average: 82,
      formula: "15d8 + 15",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 13,
    int: 18,
    wis: 16,
    cha: 14,
    save: {
      int: "+7",
      wis: "+6",
    },
    skill: {
      arcana: "+7",
      history: "+7",
      insight: "+6",
      perception: "+6",
    },
    passive: 16,
    languages: ["Common plus three other languages"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The mastermind casts one of the following spells, requiring no material components and using Intelligence as the spellcasting ability (spell save {@dc 15}):",
        ],
        will: ["{@spell alter self}", "{@spell light}", "{@spell mage hand}"],
        daily: {
          "1e": [
            "{@spell comprehend languages}",
            "{@spell mage armor}",
            "{@spell zone of truth}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The mastermind makes two Arcane Shock or Dagger of the Poisoned Mind attacks.",
        ],
      },
      {
        name: "Arcane Shock",
        entries: [
          "{@atk ms,rs} {@hit 7} to hit, reach 5 ft. or range 60 ft., one target. {@h}26 ({@damage 4d10 + 4}) lightning damage. If the target is a creature, it can't take reactions until the start of its next turn.",
        ],
      },
      {
        name: "Dagger of the Poisoned Mind",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage plus 10 ({@damage 3d6}) psychic damage. If the target is a creature, it must succeed on a {@dc 15} Wisdom saving throw or be {@condition frightened} until the end of its next turn.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["L", "P", "Y"],
    damageTagsSpell: ["B", "P", "S"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["frightened"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Scribble",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 126,
    _copy: {
      name: "Scholarly Agent",
      source: "CRCotN",
      _trait: {
        name: "Kenku",
        source: "VGM",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the agent",
          with: "Scribble",
          flags: "i",
        },
      },
    },
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["kenku", "wizard"],
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Scuttling Serpentmaw",
    source: "CRCotN",
    page: 208,
    size: ["S"],
    type: "aberration",
    alignment: ["U"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 65,
      formula: "10d6 + 30",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 14,
    con: 16,
    int: 3,
    wis: 11,
    cha: 3,
    skill: {
      stealth: "+6",
    },
    senses: ["blindsight 60 ft. (blind beyond this radius)"],
    passive: 10,
    cr: "4",
    trait: [
      {
        name: "Amphibious",
        entries: ["The serpentmaw can breathe air and water."],
      },
      {
        name: "Pack Tactics",
        entries: [
          "The serpentmaw has advantage on an attack roll against a creature if at least one of the serpentmaw's allies is within 5 feet of the creature and the ally isn't {@condition incapacitated}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The serpentmaw makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 15 ft., one target. {@h}10 ({@damage 2d6 + 3}) piercing damage, or 17 ({@damage 4d6 + 3}) piercing damage if the serpentmaw had advantage on the attack roll.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d8 + 3}) slashing damage.",
        ],
      },
    ],
    traitTags: ["Amphibious", "Pack Tactics"],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    damageTags: ["P", "S"],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Shira",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 105,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "G"],
    ac: [10],
    hp: {
      average: 4,
      formula: "1d8",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 10,
    con: 10,
    int: 10,
    wis: 10,
    cha: 10,
    passive: 10,
    languages: ["Any one language (usually Common)"],
    cr: "0",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Shira casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 10}, {@hit 2} to hit with spell attacks):",
        ],
        will: ["{@spell chill touch}"],
        daily: {
          "1e": ["{@spell blindness/deafness}", "{@spell ray of sickness}"],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Club",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}2 ({@damage 1d4}) bludgeoning damage.",
        ],
      },
    ],
    attachedItems: ["club|phb"],
    languageTags: ["C"],
    damageTags: ["B"],
    damageTagsSpell: ["I", "N"],
    spellcastingTags: ["O"],
    miscTags: ["MW"],
    conditionInflictSpell: ["blinded", "deafened", "poisoned"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Skeletal Bloodfin",
    source: "CRCotN",
    page: 159,
    _copy: {
      name: "Slithering Bloodfin",
      source: "CRCotN",
      _mod: {
        trait: {
          mode: "replaceArr",
          replace: "Water Breathing",
          items: {
            name: "Unusual Nature",
            entries: [
              "The skeletal bloodfin requires no food, drink, air, or sleep.",
            ],
          },
        },
      },
    },
    type: "undead",
    resist: ["piercing", "slashing"],
    immune: ["poison"],
    conditionImmune: [
      "charmed",
      "deafened",
      "frightened",
      "paralyzed",
      "poisoned",
    ],
    traitTags: ["Death Burst", "Unusual Nature"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Slithering Bloodfin",
    source: "CRCotN",
    page: 209,
    size: ["L"],
    type: "aberration",
    alignment: ["U"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 93,
      formula: "11d10 + 33",
    },
    speed: {
      walk: 5,
      swim: 50,
    },
    str: 20,
    dex: 14,
    con: 16,
    int: 2,
    wis: 10,
    cha: 3,
    skill: {
      perception: "+4",
    },
    senses: ["blindsight 100 ft. (blind beyond this radius)"],
    passive: 14,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    cr: "9",
    trait: [
      {
        name: "Death Burst",
        entries: [
          "When the bloodfin dies, it explodes in a cloud of toxic blood. Each creature in a 10-foot-radius sphere centered on the exploding bloodfin, including any creature swallowed by the bloodfin, must succeed on a {@dc 15} Constitution saving throw or take 10 ({@damage 3d6}) poison damage. A creature inside the bloodfin when it explodes falls {@condition prone} in the space formerly occupied by the bloodfin and is no longer {@condition blinded} or {@condition restrained} by it.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The bloodfin can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The bloodfin makes one Bite attack and one Tail attack."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit (with advantage if the target is a creature missing any hit points), reach 5 ft., one target. {@h}14 ({@damage 2d8 + 5}) piercing damage, and if the target is a creature, it is {@condition grappled} (escape {@dc 15}). Until this grapple ends, the target is {@condition restrained}, and the bloodfin can't bite another target.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 9} to hit (with advantage if the target is a creature missing any hit points), reach 10 ft., one target. {@h}19 ({@damage 4d6 + 5}) bludgeoning damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Swallow",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one Medium or smaller creature the bloodfin is grappling. {@h}The bloodfin swallows the target. The swallowed creature is no longer {@condition grappled} but is {@condition blinded} and {@condition restrained}. It has total cover against attacks and other effects outside the bloodfin, it takes 14 ({@damage 4d6}) necrotic damage at the start of each of its turns, and the bloodfin regains hit points equal to the necrotic damage dealt. A bloodfin can have only one creature swallowed at a time.",
          "If the bloodfin takes 30 damage or more on a single turn from the swallowed creature, the bloodfin must succeed on a {@dc 15} Constitution saving throw at the end of that turn or regurgitate the creature, which falls {@condition prone} in a space within 5 feet of the bloodfin and is no longer {@condition blinded} or {@condition restrained} by it.",
        ],
      },
    ],
    traitTags: ["Death Burst", "Water Breathing"],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    damageTags: ["B", "I", "N", "P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Sorrowfish",
    source: "CRCotN",
    page: 210,
    size: ["T"],
    type: "aberration",
    alignment: ["U"],
    ac: [13],
    hp: {
      average: 1,
      formula: "1d4 - 1",
    },
    speed: {
      walk: 0,
      swim: 40,
    },
    str: 2,
    dex: 16,
    con: 9,
    int: 1,
    wis: 7,
    cha: 2,
    senses: ["darkvision 60 ft."],
    passive: 8,
    immune: ["psychic"],
    cr: "0",
    trait: [
      {
        name: "Blood Frenzy",
        entries: [
          "The sorrowfish has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The Sorrowfish can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}1 piercing damage.",
        ],
      },
    ],
    traitTags: ["Water Breathing"],
    senseTags: ["D"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Swarm of Sorrowfish",
    source: "CRCotN",
    page: 210,
    size: ["M"],
    type: {
      type: "aberration",
      swarmSize: "T",
    },
    alignment: ["U"],
    ac: [14],
    hp: {
      average: 104,
      formula: "16d8 + 32",
    },
    speed: {
      walk: 0,
      swim: 30,
    },
    str: 16,
    dex: 19,
    con: 14,
    int: 1,
    wis: 11,
    cha: 3,
    senses: ["blindsight 60 ft. (blind beyond this radius)"],
    passive: 10,
    resist: ["bludgeoning", "piercing", "slashing"],
    immune: ["psychic"],
    conditionImmune: [
      "charmed",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "prone",
      "restrained",
      "stunned",
    ],
    cr: "6",
    trait: [
      {
        name: "Swarm",
        entries: [
          "The swarm can occupy another creature's space and vice versa, and the swarm can move through an opening as narrow as 1 foot wide. The swarm can't regain hit points or gain temporary hit points.",
        ],
      },
      {
        name: "Virulent Sorrow",
        entries: [
          "Each time the swarm takes damage, any creature within 5 feet of it must make a {@dc 13} Wisdom saving throw. On a failed saving throw, the creature suffers the following effects until the end of its next turn: it has disadvantage on its attack rolls, it can't take reactions, and its speed is halved.",
        ],
      },
      {
        name: "Water Breathing",
        entries: ["The swarm can breathe only underwater."],
      },
    ],
    action: [
      {
        name: "Swarm of Bites",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 0 ft., one target in the swarm's space. {@h}21 ({@damage 6d6}) piercing damage, or 10 ({@damage 3d6}) piercing damage if the swarm has half its hit points or fewer.",
        ],
      },
      {
        name: "Desolate Drain {@recharge 5}",
        entries: [
          "Each creature in the swarm's space must make a {@dc 13} Wisdom saving throw. On a failed saving throw, a creature takes 24 ({@damage 7d6}) psychic damage and is {@condition stunned} until the end of its next turn. The effect ends on a creature if the swarm moves out of the creature's space or if another creature within 5 feet of the swarm uses an action to make a {@dc 14} Strength check, pulling the affected creature out of the swarm on a successful check. On a successful saving throw, a creature takes half as much damage and suffers no other effects.",
        ],
      },
    ],
    traitTags: ["Water Breathing"],
    senseTags: ["B"],
    damageTags: ["P", "Y"],
    miscTags: ["MW"],
    conditionInflict: ["stunned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Verin Thelyss",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 51,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["drow", "elf"],
    },
    alignment: ["L", "G"],
    ac: [
      {
        ac: 17,
        from: ["{@item half plate armor|PHB|half plate}"],
      },
    ],
    hp: {
      average: 84,
      formula: "13d8 + 26",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 15,
    con: 14,
    int: 13,
    wis: 14,
    cha: 16,
    save: {
      str: "+7",
      con: "+5",
      wis: "+5",
    },
    skill: {
      athletics: "+7",
      history: "+4",
      perception: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 15,
    languages: ["Common", "Elvish", "Undercommon"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Verin casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 14}):",
        ],
        will: ["{@spell dancing lights}"],
        daily: {
          "1e": [
            "{@spell darkness}",
            "{@spell faerie fire}",
            "{@spell levitate} (self only)",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Fey Ancestry",
        entries: [
          "Verin has advantage on saving throws against being {@condition charmed}, and magic can't put him to sleep.",
        ],
      },
      {
        name: "Sunlight Sensitivity",
        entries: [
          "While in sunlight, Verin has disadvantage on attack rolls, as well as on Wisdom (Perception) checks that rely on sight.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Verin makes three Glaive attacks."],
      },
      {
        name: "Glaive",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}9 ({@damage 1d10 + 4}) slashing damage.",
        ],
      },
      {
        name: "Hand Crossbow",
        entries: [
          "{@atk rw} {@hit 7} to hit, range 30/120 ft., one target. {@h}5 ({@damage 1d6 + 2}) piercing damage plus 22 ({@damage 4d10}) poison damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Manifest Echo",
        entries: [
          "Verin magically creates an echo\u2014a translucent, gray object that looks like him. The echo appears in an unoccupied space Verin can see within 15 feet of himself. While the echo exists, Verin chooses whether each of his attacks originates from his space or the echo's space. On Verin's turn, the echo can move in accordance with Verin's wishes. The echo has AC 17 and 1 hit point. It otherwise uses Verin's statistics. The echo lasts for 1 minute or until it is destroyed, until Verin ends his turn more than 30 feet away from it, until Verin manifests another echo, or until Verin is {@condition incapacitated}.",
        ],
      },
      {
        name: "Reposition",
        entries: ["Verin magically swaps places with his echo."],
      },
    ],
    reaction: [
      {
        name: "Parry",
        entries: [
          "Verin adds 3 to his AC against one melee attack that would hit him. To do so, he must see the attacker and be wielding a melee weapon.",
        ],
      },
    ],
    attachedItems: ["glaive|phb", "hand crossbow|phb"],
    traitTags: ["Fey Ancestry", "Sunlight Sensitivity"],
    senseTags: ["SD"],
    actionTags: ["Multiattack", "Parry"],
    languageTags: ["C", "E", "U"],
    damageTags: ["I", "P", "S"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RCH", "RNG", "RW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Xot",
    isNpc: true,
    isNamedCreature: true,
    source: "CRCotN",
    page: 126,
    _copy: {
      name: "Scholarly Excavator",
      source: "CRCotN",
      _trait: {
        name: "Goliath",
        source: "VGM",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the excavator",
          with: "Xot",
          flags: "i",
        },
      },
    },
    size: ["M"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Young Horizonback Tortoise",
    source: "CRCotN",
    page: 26,
    size: ["H"],
    type: "beast",
    alignment: ["U"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 68,
      formula: "8d12 + 16",
    },
    speed: {
      walk: 30,
    },
    str: 19,
    dex: 11,
    con: 15,
    int: 2,
    wis: 12,
    cha: 5,
    passive: 11,
    languages: ["understands Goblin but can't speak"],
    cr: "3",
    trait: [
      {
        name: "Amphibious",
        entries: ["The young horizonback tortoise can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}18 ({@damage 4d6 + 4}) piercing damage. If the target is a creature, it must succeed on a {@dc 14} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
    ],
    traitTags: ["Amphibious"],
    languageTags: ["CS", "GO"],
    damageTags: ["P"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["prone"],
    hasToken: true,
  },
];
